"use strict";

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _unmutable = _interopRequireDefault(require("./internal/unmutable"));

var _get = _interopRequireDefault(require("./get"));

var _has = _interopRequireDefault(require("./has"));

var _isValueObject = _interopRequireDefault(require("./util/isValueObject")); // we're not using Immutable.js getIn because it can't cope with mixed types in the keyPath


var _default = (0, _unmutable["default"])({
  name: 'getIn',
  all: function all(keyPath) {
    var notFoundValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
    return function (value) {
      var ii = value;
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = keyPath[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var key = _step.value;

          if (!(0, _isValueObject["default"])(ii) || !(0, _has["default"])(key)(ii)) {
            return notFoundValue;
          }

          ii = (0, _get["default"])(key)(ii);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator["return"] != null) {
            _iterator["return"]();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return ii;
    };
  }
});

exports["default"] = _default;